import React from "react";
import styles from "./ChannelPartner.module.css";
import Hero from "./Hero/Hero";
import About from "./About/About";
import WhyPartner from "./WhyPartner/WhyPartner";
import WhyChoose from "./WhyChoose/WhyChoose";
import Products from "./Products/Products";
import FranchiseUSP from "./FranchiseUSP/FranchiseUSP";
import Advantages from "./Advantages/Advantages";
import Training from "./Training/Training";
import Revenue from "./Revenue/Revenue";
import Gallery from "./Gallery/Gallery";
import CTAForm from "../CTAForm/CTAForm";
import InternationalPartnership from "./InternationalPartnership/InternationalPartnership";

const ChannelPartner = () => {
  return (
    <div className={styles.channelPartner}>
      <Hero />
      <About />
      <WhyPartner />
      <WhyChoose />
      <InternationalPartnership />

      <Products />
      <FranchiseUSP />
      <Advantages />
      <Training />
      <Revenue />
      <Gallery />
      <CTAForm />
    </div>
  );
};

export default ChannelPartner;
